/**
 * Created by Ivan on 03.06.2025
 */

RewardsConfig.KingsCup = [
    {
        boosters: {
            before_cheap: 3,
            before_medium: 3,
            before_expensive: 3,
            cheap: 1,
            medium: 1,
            expensive: 1
        },
        unlimitedLives: "3 hours"
    },
    {
        boosters: {
            before_cheap: 2,
            before_medium: 2,
            before_expensive: 2,
            cheap: 1,
            medium: 1
        },
        unlimitedLives: "2 hours"
    },
    {
        boosters: {
            before_cheap: 2,
            before_medium: 2,
            before_expensive: 2
        },
        unlimitedLives: "1 hour"
    },
    {
        boosters: {
            before_cheap: 1,
            before_medium: 1,
            before_expensive: 1
        }
    },
    {
        boosters: {
            before_cheap: 1,
            before_medium: 1,
            before_expensive: 1
        }
    },
    {
        boosters: {
            before_cheap: 1,
            before_medium: 1,
            before_expensive: 1
        }
    },
    {
        boosters: {
            before_cheap: 1,
            before_medium: 1,
            before_expensive: 1
        }
    },
    {
        boosters: {
            before_cheap: 1,
            before_medium: 1,
            before_expensive: 1
        }
    },
    {
        boosters: {
            before_cheap: 1,
            before_medium: 1,
            before_expensive: 1
        }
    },
    {
        boosters: {
            before_cheap: 1,
            before_medium: 1,
            before_expensive: 1
        }
    }
];

RewardsConfig.KingsCupOffer = {
    hard: 1400,
    boosters: {
        cheap: 2,
        medium: 1
    }
};

RewardsConfig.KingsCupWelcomeBonus = {
    boosters: {
        cheap: 1
    }
};

if (cleverapps.config.type === "match3") {
    RewardsConfig.KingsCupWelcomeBonus = {
        unlimitedLives: "30 minutes"
    };
}

if (cleverapps.config.type === "merge2") {
    RewardsConfig.KingsCup = [
        { units: [{ code: "aa", stage: 0 }, { code: "ff", stage: 2 }, { code: "ff", stage: 0 }], energy: 200, stickers2VioletPack: 1 },
        { units: [{ code: "ff", stage: 1 }, { code: "ff", stage: 3 }], energy: 100, stickers2BluePack: 1 },
        { units: [{ code: "ff", stage: 1 }, { code: "cc", stage: 2 }], energy: 50, stickers2GreenPack: 1 },
        { units: [{ code: "cc", stage: 1 }], energy: 30 },
        { units: [{ code: "cc", stage: 1 }], energy: 30 },
        { units: [{ code: "cc", stage: 1 }], energy: 30 },
        { units: [{ code: "cc", stage: 1 }], energy: 30 },
        { units: [{ code: "cc", stage: 1 }], energy: 30 },
        { units: [{ code: "cc", stage: 1 }], energy: 30 },
        { units: [{ code: "cc", stage: 1 }], energy: 30 }
    ];

    RewardsConfig.KingsCupWelcomeBonus = {
        energy: 25
    };
}

if (cleverapps.config.type === "merge") {
    RewardsConfig.KingsCupOffer = {
        energy: 250,
        worker: Product.FormatTimePeriod("1 day", true)
    };

    RewardsConfig.KingsCupWelcomeBonus = {
        energy: 100
    };

    RewardsConfig.KingsCup = [{
        unit: [
            { code: "treasure", stage: 2, amount: 1 },
            { code: "herochest", stage: 1, amount: 1 },
            { code: "crystal", stage: 1, amount: 1 }
        ],
        stickers2RedPack: 1
    }, {
        unit: [
            { code: "treasure", stage: 1, amount: 1 },
            { code: "herochest", stage: 0, amount: 1 },
            { code: "crystal", stage: 0, amount: 2 }
        ],
        stickers2VioletPack: 1
    }, {
        unit: [
            { code: "treasure", stage: 0, amount: 1 },
            { code: "sacks", stage: 2, amount: 2 }
        ],
        stickers2BluePack: 1
    }];
}
